import transparenciaMetadata from './data/metadata.json';
import type { TransparenciaSnapshotsDataVersion } from './types.js';

export const TRANSPARENCIA_SNAPSHOTS_DATA_VERSION: TransparenciaSnapshotsDataVersion =
  transparenciaMetadata as TransparenciaSnapshotsDataVersion;
